import { handleApiError } from '@/utils/errorHandler';
import { authSignUpVerify } from '@auth/authApi';
import FuseLoading from '@fuse/core/FuseLoading';
import useNavigate from '@fuse/hooks/useNavigate';
import useQuery from '@fuse/hooks/useQuery';
import { useEffect } from 'react';
import toast from 'react-hot-toast';


export default function SignUpVerifyPage() {
  const query = useQuery();
  const navigate = useNavigate();

  useEffect(() => {

    if (!(query.has('key'))) {
      toast.error('Incorrect url. Please contact support if the issue persists.');
      navigate('/sign-in');
    }

    handleVerify();


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleVerify = async () => {
    try {

      await authSignUpVerify({ key: query.get('key') });
      toast.success('Email confirmed. Please sign in');
      navigate('/sign-in');
    } catch (err) {
      handleApiError(err, { messagePrefix: 'Error confirming your email.' });
      navigate('/sign-in');
    }

  };

  return <div className='w-full h-screen flex justify-center items-center flex-col'>
    <FuseLoading />
  </div>;

}
